/* ============================================================
   convx.js — Extended Theme Logic
   Includes: KS Chart replacement + Sticky ATC (AJAX + Drawer)
   Code by Justin 
============================================================ */

(function () {
  "use strict";

  /* -----------------------------------------------
     Sticky Add-to-Cart: Initialization
  ----------------------------------------------- */
  function initStickyATC() {
    const bar = document.getElementById("sticky-atc");
    if (!bar) return;

    // Move bar to <body> to ensure position:fixed works
    try {
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
    } catch (e) {}

    const formMain = document.querySelector('product-form form, form[action*="/cart/add"]');
    const idInputMain = formMain ? formMain.querySelector('[name="id"]') : null;

    const formSticky = document.getElementById("sticky-atc-form");
    const idInputSticky = formSticky ? formSticky.querySelector('[name="id"]') : null;

    const priceEl = document.getElementById("sticky-atc-price");
    const imgEl = document.getElementById("sticky-atc-image");
    const optsEl = document.getElementById("sticky-atc-options");

    let variants = [];
    try {
      variants = JSON.parse(document.getElementById("StickyATCVariants").textContent);
    } catch (e) {}

    // --- Helper functions
    const formatMoney = (cents) => {
      if (window.Shopify && Shopify.formatMoney)
        return Shopify.formatMoney(cents, window.theme && theme.moneyFormat || undefined);
      return "RM " + (cents / 100).toFixed(2);
    };

    const findVariant = (id) => variants.find((v) => String(v.id) === String(id));

    const renderVariant = (variant) => {
      if (!variant) return;
      if (!idInputSticky) return;

      // update id
      idInputSticky.value = variant.id;

      // price
      if (priceEl) {
        let html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ` <s class="sticky-atc__compare style="color: red;">${formatMoney(variant.compare_at_price)}</s>`;
        }
        priceEl.innerHTML = html;
      }

      // options
      if (optsEl && variant.options && variant.options.length) {
        optsEl.textContent = variant.options.join(" / ");
      }

      // image
      if (imgEl && variant.featured_image && variant.featured_image.src) {
        const src = variant.featured_image.src.replace(/(\.jpg|\.jpeg|\.png)(\?.*)?$/i, "$1");
        imgEl.src = `${src}?width=160`;
      }

      // button state
      const btn = formSticky.querySelector(".sticky-atc__btn");
      if (btn) {
        if (variant.available) {
          btn.removeAttribute("disabled");
          btn.textContent = "ADD TO CART";
        } else {
          btn.setAttribute("disabled", "disabled");
          btn.textContent = "SOLD OUT";
        }
      }
    };

    // initial render
    if (idInputMain && idInputMain.value) renderVariant(findVariant(idInputMain.value));
    else if (idInputSticky && idInputSticky.value)
      renderVariant(findVariant(idInputSticky.value));

    // sync variant change
    if (idInputMain) {
      const mo = new MutationObserver(() =>
        renderVariant(findVariant(idInputMain.value))
      );
      mo.observe(idInputMain, { attributes: true, attributeFilter: ["value"] });
      idInputMain.addEventListener("change", () =>
        renderVariant(findVariant(idInputMain.value))
      );
      document.addEventListener(
        "variant:changed",
        (e) => {
          if (e.detail && e.detail.variant) renderVariant(e.detail.variant);
        },
        true
      );
    }

    /* -----------------------------------------------
       Sticky Show Logic (scroll depth)
    ----------------------------------------------- */
    const showStickyOnScroll = () => {
      const scrollDepthDesktop = 600; // px
      const scrollDepthMobile = 300; // px
      const triggerDepth =
        window.innerWidth < 768 ? scrollDepthMobile : scrollDepthDesktop;

      window.addEventListener("scroll", () => {
        if (window.scrollY > triggerDepth) {
          bar.classList.add("sticky-atc--show", "sticky-atc--full");
          bar.hidden = false;
        } else {
          bar.classList.remove("sticky-atc--show", "sticky-atc--full");
          bar.hidden = true;
        }
      });
    };
    showStickyOnScroll();

    /* -----------------------------------------------
       AJAX Add-to-Cart + Drawer Open
    ----------------------------------------------- */
    if (formSticky) {
      formSticky.addEventListener(
        "submit",
        async (e) => {
          e.preventDefault();

          const btn = formSticky.querySelector(".sticky-atc__btn");
          const idInput = formSticky.querySelector('[name="id"]');
          if (!idInput || !idInput.value) return;

          try {
            if (btn) {
              btn.disabled = true;
              btn.dataset.old = btn.textContent;
              btn.textContent = "ADDING…";
            }

            const fd = new FormData(formSticky);
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { Accept: "application/json" },
              body: fd,
            });
            if (!res.ok) throw new Error("Add to cart failed");

            // Update drawer section
            try {
              const secRes = await fetch(
                `${window.location.pathname}?sections=cart-drawer`,
                { headers: { Accept: "application/json" } }
              );
              if (secRes.ok) {
                const sections = await secRes.json();
                const container = document.getElementById("shopify-section-cart-drawer");
                if (container && sections["cart-drawer"]) {
                  container.innerHTML = sections["cart-drawer"];
                }
              }
            } catch (err) {
              console.warn("Drawer update failed", err);
            }

            // Open drawer
            const drawerEl =
              document.getElementById("cart-drawer") ||
              document.querySelector("cart-drawer") ||
              document.querySelector("[data-cart-drawer], .cart-drawer");

            if (drawerEl) {
              drawerEl.classList.add("open", "is-open");
              drawerEl.setAttribute("open", "");
              if (typeof drawerEl.open === "function") drawerEl.open();
              if (typeof drawerEl.show === "function") drawerEl.show();
            }

            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
            );
          } catch (err) {
            console.error("[sticky-atc] add error", err);
            alert("Unable to add to cart. Please try again.");
          } finally {
            if (btn) {
              btn.disabled = false;
              btn.textContent = btn.dataset.old || "ADD TO CART";
            }
          }
        },
        { passive: false }
      );
    }
  }

  /* -----------------------------------------------
     DOMContentLoaded Entry
  ----------------------------------------------- */
  function onDOMContentLoaded() {
    const path = location.pathname;
    const isProducts = path.includes("/products");

    if (isProducts) {
      initStickyATC();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, { once: true });
  } else {
    onDOMContentLoaded();
  }
})();
